import React from "react";
import "./LiquidGlass.css";
import EastIcon from "@mui/icons-material/East";
import GlassCardForButtons from "../GlassCard/GlassCardForButtons";

const LiquidGlassButton = () => {
  return (
    <GlassCardForButtons>
      <svg width="13" height="11" viewBox="0 0 13 11" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0.5 5.5H11.9826M7.56621 0.5L12.2413 4.91074C12.5862 5.23618 12.5862 5.76382 12.2413 6.08926L7.56621 10.5" stroke="white" stroke-linecap="round" />
      </svg>
    </GlassCardForButtons>
  );
};

export default LiquidGlassButton;
